import React from 'react';
import * as FiIcons from 'react-icons/fi';
import { FiAlertTriangle } from 'react-icons/fi';

const SafeIcon = ({ icon, name, ...props }) => {
  let IconComponent;
  
  try {
    // Handle case where icon is just a string name (e.g. from JSON data)
    if (typeof icon === 'string') {
      IconComponent = FiIcons[icon] || FiIcons[`Fi${icon}`];
    } else {
      // Handle case where icon is a component passed directly
      IconComponent = icon;
    }

    // Fallback to name prop if icon didn't resolve
    if (!IconComponent && name) {
      IconComponent = FiIcons[name] || FiIcons[`Fi${name}`];
    }
  } catch (e) {
    IconComponent = null;
  }

  return IconComponent ? React.createElement(IconComponent, props) : <FiAlertTriangle {...props} />;
};

export default SafeIcon;